/* eslint-disable */
import StorePlugin from '../plugin/StorePlugin';
import infraMutations from "../store/infra/mutations";

class StoreFactory {
  constructor(appKey, Vue) {
    this.__Vue = Vue;
    this.__appKey = appKey;
    this.__config = {};
  }

  load(config, includeInfraFunctionality = true) {
    //extend config store functionality with infra functionality.
    if (includeInfraFunctionality) {
      config.actions = config.actions || {};
      config.getters = config.getters || {};
      config.mutations = config.mutations || {};

      Object.assign(config.mutations, infraMutations);
    }
    this.__config = Object.assign(this.__config, config);
  }

  register(store) {
    const st = store || this.__Vue.options && this.__Vue.options.store || StorePlugin.store;
    const stores = {};

    if (this.__appKey && !stores[this.__appKey]) {
      stores[this.__appKey] = this.__config;
      StorePlugin.load({ stores });
    }

    return st;
  }
}

export default StoreFactory;



// WEBPACK FOOTER //
// ./src/factory/StoreFactory.js